module.exports = __webpack_public_path__ + "img/image8.ba30bca5.png";